import { SUMMONER_SPELLS } from '../summonerSpells.js';

/**
 * summonerSpellMapRules — Per-map summoner allow/deny (P3-31).
 * ARAM: no Teleport, no Smite (S2 Proving Grounds).
 */
export const BANNED_SUMMONERS_BY_MAP = {
  aram_proving_grounds: new Set(['teleport', 'smite'])
};

export function isSummonerSpellAllowed(spellId, mapId) {
  if (!SUMMONER_SPELLS[spellId]) return false;
  const banned = BANNED_SUMMONERS_BY_MAP[mapId];
  if (!banned) return true;
  return !banned.has(spellId);
}

export function listAllowedSummonerSpells(mapId) {
  return Object.keys(SUMMONER_SPELLS).filter((id) => isSummonerSpellAllowed(id, mapId));
}

export function sanitizeSummonerPairForMap(spell1, spell2, mapId) {
  const allowed = listAllowedSummonerSpells(mapId);
  let a = isSummonerSpellAllowed(spell1, mapId) ? spell1 : allowed[0];
  let b = isSummonerSpellAllowed(spell2, mapId) ? spell2 : allowed[1] || allowed[0];
  if (a === b) {
    b = allowed.find((id) => id !== a) || b;
  }
  return [a, b];
}

/** Full spellId → allowed bool per map (P3-33 matrix tests / docs). */
export function buildSummonerSpellMapMatrix(mapIds) {
  const spells = Object.keys(SUMMONER_SPELLS);
  const matrix = {};
  mapIds.forEach((mapId) => {
    matrix[mapId] = {};
    spells.forEach((spellId) => {
      matrix[mapId][spellId] = isSummonerSpellAllowed(spellId, mapId);
    });
  });
  return matrix;
}
